<template>
  <div>
    <vTableEditable
      v-if="isAdmin"
      :table="table"
      :items="items"
      :headers="headers"
      :title="title"
      :items-per-page="itemsPerPage"
      @field-updated="fieldUpdated"
      @selection-made="emitItemsSelected"
      @item-deleted="itemDeleted"
    ></vTableEditable>
    <vTable
      v-else
      :table="table"
      :items="items"
      :headers="headers"
      :title="title"
      :items-per-page="itemsPerPage"
    ></vTable>
  </div>
</template>

<script>
import vTable from "@/components/Legos/vTable.vue";
import vTableEditable from "@/components/Legos/vTableEditable.vue";

export default {
  props: {
    table: {
      default: null,
    },
    headers: {
      default: [],
    },
    items: {
      default: [],
    },
    title: {
      default: null,
    },
    itemsPerPage: {
      default: 10,
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  components: { vTable, vTableEditable },
  data: () => ({}),
  methods: {
    emitItemsSelected(selectedItems) {
      this.$emit("items-selected", selectedItems);
    },
    fieldUpdated(arr) {
      this.$emit("input-field-updated", arr);
    },
    itemDeleted() {
      this.$emit("item-deleted");
    },
  },
};
</script>

<style></style>
